export { getAskDoctorV2Configuration } from './utils.graphql';
export { useAskDoctorResponseDialog } from './AskDoctorResponseDialog';
